import React from 'react';
import { CCarousel, CCarouselItem} from '@coreui/react'
import { makeStyles } from '@material-ui/core/styles';

function Carousel({children}) {
  const classes = useStyles();
  return (
    <CCarousel controls indicators dark interval={false}>
      <CCarouselItem>
        <p className={classes.text}>
        Chaque section vaut un certain nombre de points et plus vous avez de points à la fin du test plus votre récompense sera élevée, pouvant aller jusqu'à 50 $ lorsque vous dépasserez 500 points.
        </p>
      </CCarouselItem>
      <CCarouselItem>
        {children}
      </CCarouselItem>
    </CCarousel>
  );
}

const useStyles = makeStyles({
    text: {
        'margin': '40px 120px',
        'min-height': '30vh',
        'line-height': 1.3,
        'align-items': 'center',
        'justify-content': 'center',
    },
})

export default Carousel;
